/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */
/* eslint-disable */

// Lib imports
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index'
import userService from '@/services/userService'

// Routes
import paths from './paths'

// function route (path, view, name) {
//     return {
//         name: name || view,
//         path,
//         component: (resovle) => import(
//             `@/views/${view}.vue`
//         ).then(resovle)
//     }
// }

function hasUserDto() {
    return !!store.state.auth.spillsUserDto
}

function userHasRoleList() {
    let spillsUserDto = store.state.auth.spillsUserDto || {}
    //check if user has roleList or not
    return !!(spillsUserDto.roleList && spillsUserDto.roleList.length > 0)
}

function hasAdminAccess() {
    return userService.isAdministrator()
}

// Create a new router
const router = createRouter({
    history: createWebHistory(),
//   routes: paths.map(path => route(path.path, path.view, path.name)).concat([
//     { path: '*', redirect: '/home' }
//   ]),
    routes: paths,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    }
})

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
    Vue.use(VueAnalytics, {
        id: process.env.GOOGLE_ANALYTICS,
        router,
        autoTracking: {
            page: process.env.NODE_ENV !== 'development'
        }
    })
}

//auth behavior
router.beforeEach((to, from, next) => {
    //if path requiresAuth, do check
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // if (!auth.isAuthenticated()) {
        //     //auth.logout()
        //     store.dispatch('logout')
        //     alert('Your login session is timed out/ended.')
        //     next({ path: '/logout' })
        //     return
        // }
        if (!hasUserDto()) {
            alert('Cannot obtain user information')
            router.push('/home', () => { location.reload() })
            return
        }
        if (!userHasRoleList()) {
            alert('Cannot obtain user role.')
            router.push('/user-profile', () => { location.reload() })
            return
        }
        if (to.matched.some(record => record.meta.requiresAdmin && !hasAdminAccess())) {
            alert('User does not have access.')
            router.push('/home', () => { location.reload() })
            return
        }
        next()
    } else {
        next()
    }
})

export default router
